export const organisationConstants = {
  CREATE_ORGANISATION_REQUEST: 'CREATE_ORGANISATION_REQUEST',
  CREATE_ORGANISATION_SUCCESS: 'CREATE_ORGANISATION_SUCCESS',
  CREATE_ORGANISATION_FAILURE: 'CREATE_ORGANISATION_FAILURE',

  UPDATE_ORGANISATION_REQUEST: 'UPDATE_ORGANISATION_REQUEST',
  UPDATE_ORGANISATION_SUCCESS: 'UPDATE_ORGANISATION_SUCCESS',
  UPDATE_ORGANISATION_FAILURE: 'UPDATE_ORGANISATION_FAILURE',

  CREATE_ORGANISATION_USER_REQUEST: 'CREATE_ORGANISATION_USER_REQUEST',
  CREATE_ORGANISATION_USER_SUCCESS: 'CREATE_ORGANISATION_USER_SUCCESS',
  CREATE_ORGANISATION_USER_FAILURE: 'CREATE_ORGANISATION_USER_FAILURE',

  GET_ORGANISATION_USERS_REQUEST: 'GET_ORGANISATION_USERS_REQUEST',
  GET_ORGANISATION_USERS_SUCCESS: 'GET_ORGANISATION_USERS_SUCCESS',
  GET_ORGANISATION_USERS_FAILURE: 'GET_ORGANISATION_USERS_FAILURE',

  GET_MY_ORGANISATION_REQUEST: 'GET_MY_ORGANISATION_REQUEST',
  GET_MY_ORGANISATION_SUCCESS: 'GET_MY_ORGANISATION_SUCCESS',
  GET_MY_ORGANISATION_FAILURE: 'GET_MY_ORGANISATION_FAILURE',

  GET_ORGANISATION_REQUEST: 'GET_ORGANISATION_REQUEST',
  GET_ORGANISATION_SUCCESS: 'GET_ORGANISATION_SUCCESS',
  GET_ORGANISATION_FAILURE: 'GET_ORGANISATION_FAILURE',

  DELETE_ORGANISATION_USER_REQUEST: 'DELETE_ORGANISATION_USER_REQUEST',
  DELETE_ORGANISATION_USER_SUCCESS: 'DELETE_ORGANISATION_USER_SUCCESS',
  DELETE_ORGANISATION_USER_FAILURE: 'DELETE_ORGANISATION_USER_FAILURE',
};
